module.exports = __webpack_public_path__ + "img/Wandering-Albatross.20ebb998.png";